import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gfu-grid__cell gfu-1of1 _my-6" }
const _hoisted_2 = { class: "gfu-heading gfu-heading--text _tc--dark" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_credit_card_overview = _resolveComponent("credit-card-overview")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.Resources.AccountSettings.SavedCreditCardsSectionTitle), 1 /* TEXT */),
    _createElementVNode("p", null, _toDisplayString($options.storedCreditCardsCopy), 1 /* TEXT */),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.savedCards, (card) => {
      return (_openBlock(), _createBlock(_component_credit_card_overview, {
        key: card.userCreditCardID,
        "image-url": card.cardImageUrl,
        name: card.cardName,
        "card-id": card.userCreditCardID,
        "masked-number": card.cardMaskedNumber,
        onDeleteCard: $options.onDelete
      }, null, 8 /* PROPS */, ["image-url", "name", "card-id", "masked-number", "onDeleteCard"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}